import { Button } from "@mui/material";
import { styled } from '@mui/material/styles';
import { PopupButton } from "../../styles/buttonStyles";

export const PhoneLogoImg = styled('img')({
    aspectRatio: "1/1",
    width: "90px"
});

export const ConfirmPhoneButton = styled(PopupButton)(({ theme }) => ({
    width: "100%",
    height: 50,
    "&:disabled": {
        backgroundColor: theme.palette.dialog.primaryButton.backgroundDisabled
    },
    "&.MuiButtonBase-root:hover": {
        backgroundColor: theme.palette.dialog.primaryButton.backgroundHover
    },
    "&.MuiButtonBase-root:hover:disabled": {
        backgroundColor: theme.palette.dialog.primaryButton.backgroundDisabled
    }
}));

export const InputStyled = styled('input')({
    width: '150px',
    borderRadius: '10px',
    height: '30px',
    fontSize: '24px',
    padding: '3px 10px 3px 15px',
    border: 'solid gray 1px',
    margin: '10px 0 0 0',
    "&::placeholder": {
        fontStyle: "italic",
        opacity: 0.5
    }
});

export const EmailConfirmImg = styled('img')({
    aspectRatio: '1/1',
    height: '80px',
    alignSelf: 'center',
    marginLeft: '5px'
});